export const AVATAR_EMOJIS = {
  bear: '🐻',
  lion: '🦁',
  rabbit: '🐰',
  cat: '🐱',
  dog: '🐶',
  owl: '🦉',
  fox: '🦊',
  penguin: '🐧',
  frog: '🐸',
  chick: '🐥',
  hamster: '🐹',
  panda: '🐼',
  butterfly: '🦋',
  dragon: '🐉',
  dino: '🦖',
  unicorn: '🦄',
};
